export default "__VITE_ASSET__uHHNIdIl__"